var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.3457,
    height: 39.3457,
    rx: 7.15377,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.934 20.4148L24.4679 16.9456H21.1281V14.6943C21.1281 13.7452 21.5946 12.82 23.0905 12.82H24.609V9.86649C24.609 9.86649 23.2309 9.63208 21.9134 9.63208C19.1628 9.63208 17.3651 11.2936 17.3651 14.3015V16.9456H14.3076V20.4148H17.3651V28.8015C17.9781 28.8973 18.6065 28.9473 19.2466 28.9473C19.8867 28.9473 20.5151 28.8973 21.1281 28.8015V20.4148H23.934Z",
    fill: "url(#paint0_linear_2117_5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2117_5",
    x1: 19.4571,
    y1: 28.5042,
    x2: 19.4579,
    y2: 10.1492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6AE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615447"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFFacebook);
export default __webpack_public_path__ + "static/media/f-facebook.b6918094c82e5f23fdbab78d75776456.svg";
export { ForwardRef as ReactComponent };